import { render } from "./MySelect.vue?vue&type=template&id=43420f67"
import script from "./MySelect.vue?vue&type=script&lang=js"
export * from "./MySelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__